import { Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAnimateEvent]',
  standalone: false
})
export class AnimateEventDirective {
  @Input('appAnimateEvent') set triggerAnimate(value: boolean) {
    if (value) {
      this.renderer.removeClass(this.elRef.nativeElement, this.animateEventClass);
      this.window.requestAnimationFrame(() => {
        this.renderer.addClass(this.elRef.nativeElement, this.animateEventClass);
      });
    }
  }

  @Input() animateEventClass = '';

  constructor(
    @Inject('Window') private window: Window,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {}
}
